import { createSlice } from "@reduxjs/toolkit";
import { INTERNAL_CHAT } from "../../../constants/reducer_names";
import { getCoChatChannelsDetails } from "../../api/cochat";
import * as helper from "../../helpers/get_agent_status";
const initialState = {
    loading: false,
    error: {
        hasError: false,
        errorMessage: "",
  },
    internalChatDetails: {} as any,
    searchAgentName: "" ,
    agentList: [] as any,
    agentnameList: [] as any,
    messageList: [] as any,
    internalchatmessage: "",
    isModalVisible: false,
    internalCheckallAgent:[] as any,
    selectAgentShow: '',
    
    
}
const internalChatSlice = createSlice({
    name: INTERNAL_CHAT,
    initialState,
    reducers:{
        internalChatDetails: (state, { payload }) => {
            state.internalChatDetails = payload.internalChatDetails;
          },
        internalChatsendMessage: (state, { payload }) => {
            const internalchatmessages = state?.internalChatDetails?.messages??[];
            internalchatmessages?.push(payload?.internalchatmessage);
            state.internalChatDetails = { ...state.internalChatDetails, messages: internalchatmessages };
          },
          internalCheckallAgent : (state, { payload }) => {
            state.internalCheckallAgent = payload.internalCheckallAgent;
          },
          selectAgentShow : (state, { payload }) => {
            state.selectAgentShow = payload.selectAgentShow;
          },
        
        //   updateMessage: (state, { payload }) => {
        //     state.messageList.push(payload.messageList)
        //   },
         
        searchAgentName: (state, { payload }) => {
            state.searchAgentName = payload;
            if (payload.length < 1) {
              state.agentList = state.agentnameList;
            } else {
              if (state.agentnameList.length > 0) {
                state.agentList = helper.agentSearchData(
                  state.agentnameList,
                  payload
                );
              }
            }
          },
        agentnameList: (state, { payload }) => {
            state.agentnameList = payload;
          },
          showModal : (state) => {
            state.isModalVisible = true;
            },
        
          handleOk : (state) => {
            state.isModalVisible = false;
          },
         handleCancel :(state) => {
          state.isModalVisible = false;
          },
          
         
          reset: () => {},
    },
    extraReducers: (builder) => {
        builder.addCase(getCoChatChannelsDetails.pending, (state, _) => {
          state.loading = true;
        });
        builder.addCase(getCoChatChannelsDetails.fulfilled, (state, { payload }: any) => {
          if (payload?.data?.statusCode === 200) {
            // state.internalChatDetails = payload.data?.getGroupChatIdRes;
          } else {
            state.internalChatDetails = {};
          }
          state.loading = false;
        });
        builder.addCase(getCoChatChannelsDetails.rejected, (state, _) => {
          state.loading = false;
        }); 
      },
});
export const internalChatActions = internalChatSlice.actions;
export default internalChatSlice.reducer;